export const filterScoredHazards = (state) => {
    const scoring = state.pages.inspectionDetail.inspection?.scoring;

    return scoring?.filter((hazard) => hazard.scoring != null);
};
